import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cabildo',
  templateUrl: './cabildo.component.html',
  styleUrls: ['./cabildo.component.css']
})
export class CabildoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
